(function(){
  document.querySelectorAll('a[href^="#"]').forEach(function(link){
    link.addEventListener('click',function(event){
      var target=link.getAttribute('href');
      if(!target||target==='#')return;
      var element=document.querySelector(target);
      if(element){event.preventDefault();element.scrollIntoView({behavior:'smooth'});}
    });
  });
  var trigger=document.querySelector('.menu-trigger');
  var menu=document.getElementById('vailanto-menu');
  if(!trigger||!menu)return;
  var closeButton=menu.querySelector('.vailanto-menu-close');
  var backdrop=document.querySelector('[data-menu-backdrop]');
  var openLabel=trigger.getAttribute('aria-label');
  var closeLabel=closeButton?closeButton.getAttribute('aria-label'):openLabel;
  var previousFocus=null;
  function isOpen(){return menu.classList.contains('is-open');}
  function setOpen(open){
    menu.classList.toggle('is-open',open);
    document.body.classList.toggle('vailanto-menu-open',open);
    trigger.setAttribute('aria-expanded',String(open));
    trigger.setAttribute('aria-label',open?closeLabel:openLabel);
    menu.setAttribute('aria-hidden',String(!open));
    if(open){previousFocus=document.activeElement;if(closeButton)closeButton.focus();}
    else if(menu.contains(document.activeElement)){(previousFocus&&previousFocus.focus?previousFocus:trigger).focus();}
  }
  trigger.addEventListener('click',function(){setOpen(!isOpen());});
  if(closeButton)closeButton.addEventListener('click',function(){setOpen(false);trigger.focus();});
  if(backdrop)backdrop.addEventListener('click',function(){setOpen(false);});
  menu.querySelectorAll('a').forEach(function(link){link.addEventListener('click',function(){setOpen(false);});});
  document.addEventListener('keydown',function(event){
    if(!isOpen())return;
    if(event.key==='Escape'){event.preventDefault();setOpen(false);trigger.focus();return;}
    if(event.key!=='Tab')return;
    var els=Array.prototype.slice.call(menu.querySelectorAll('button,a[href]')).filter(function(el){return !el.disabled;});
    if(!els.length)return;
    if(event.shiftKey&&document.activeElement===els[0]){event.preventDefault();els[els.length-1].focus();}
    else if(!event.shiftKey&&document.activeElement===els[els.length-1]){event.preventDefault();els[0].focus();}
  });
})();
